import React from 'react';
import { createRoot } from 'react-dom/client';
import ArtistChat from './components/ArtistChat';

// Wait for React and ReactDOM to be available
function waitForDependencies(timeout = 5000) {
  const start = Date.now();
  
  return new Promise((resolve, reject) => {
    function check() {
      if (window.React && window.ReactDOM && window.ReactDOM.createRoot) {
        resolve();
      } else if (Date.now() - start > timeout) {
        reject(new Error('Timeout waiting for React dependencies'));
      } else {
        setTimeout(check, 100);
      }
    }
    check();
  });
}

// Main initialization function
async function init(selector, options = {}) {
  try {
    //console.log('Starting chat initialization with options:', options);
    
    // Wait for dependencies
    await waitForDependencies();
    //console.log('Dependencies loaded');
    
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Container ${selector} not found`);
    }
    //console.log('Container found');

    const root = createRoot(container);
    root.render(React.createElement(ArtistChat, options));
    
    //console.log('Chat component initialized successfully');
    return true;
  } catch (error) {
    console.error('Failed to initialize chat:', error);
    throw error;
  }
}

// Export for global access
if (typeof window !== 'undefined') {
  window.SuprSketchChat = {
    init: init
  };
  //console.log('SuprSketchChat initialized with init function');
}

export { init };